import { render, staticRenderFns } from "./M2MOrderDialog.vue?vue&type=template&id=143ef150&scoped=true&"
import script from "./M2MOrderDialog.vue?vue&type=script&lang=js&"
export * from "./M2MOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./M2MOrderDialog.vue?vue&type=style&index=0&id=143ef150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ef150",
  null
  
)

export default component.exports